
export default {
    name: 'FlytippingMap',
    data() {
        return {
            initialLocation: {
                zoomType: this.$route.params.type ? this.$route.params.type : null,
                lat: this.$route.query.lat ? parseFloat(this.$route.query.lat) : null,
                lng: this.$route.query.lng ? parseFloat(this.$route.query.lng) : null,
                closed: parseInt(this.$route.query.closed, 10) === 1,
            },
        };
    },
    head() {
        return {
            link: [{ rel: 'canonical', href: `${this.$config.domain}${this.$route.path}` }],
        };
    },
};
